const API_URL = process.env.REACT_APP_API_URL || '/api';

const getHeaders = (isFormData = false) => {
  const token = localStorage.getItem('admin_token');
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (!isFormData) headers['Content-Type'] = 'application/json';
  return headers;
};

const handleResponse = async (res) => {
  // Token scaduto/invalido: pulisci sessione e torna al login
  if (res.status === 401 && localStorage.getItem('admin_token')) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_username');
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }
  const data = await res.json();
  if (!res.ok || !data.success) {
    throw new Error(data.error || 'Errore sconosciuto');
  }
  return data;
};

export const api = {
  // Auth
  login: (username, password) =>
    fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    }).then(handleResponse),

  changePassword: (body) =>
    fetch(`${API_URL}/auth/password`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(body),
    }).then(handleResponse),

  // Brands admin
  getBrands: () =>
    fetch(`${API_URL}/brands`, { headers: getHeaders() }).then(handleResponse),

  getBrand: (id) =>
    fetch(`${API_URL}/brands/${id}`, { headers: getHeaders() }).then(handleResponse),

  createBrand: (formData) =>
    fetch(`${API_URL}/brands`, {
      method: 'POST',
      headers: getHeaders(true),
      body: formData,
    }).then(handleResponse),

  updateBrand: (id, formData) =>
    // POST invece di PUT: PHP non popola $_POST/$_FILES con PUT + multipart
    fetch(`${API_URL}/brands/${id}`, {
      method: 'POST',
      headers: getHeaders(true),
      body: formData,
    }).then(handleResponse),

  deleteBrand: (id) =>
    fetch(`${API_URL}/brands/${id}`, {
      method: 'DELETE',
      headers: getHeaders(),
    }).then(handleResponse),

  toggleBrand: (id) =>
    fetch(`${API_URL}/brands/${id}/toggle`, {
      method: 'PATCH',
      headers: getHeaders(),
    }).then(handleResponse),

  sortBrands: (items) =>
    fetch(`${API_URL}/brands/sort`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify({ items }),
    }).then(handleResponse),

  // Regions admin
  getRegions: () =>
    fetch(`${API_URL}/regions`, { headers: getHeaders() }).then(handleResponse),

  createRegion: (name) =>
    fetch(`${API_URL}/regions`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ name }),
    }).then(handleResponse),

  updateRegion: (id, name) =>
    fetch(`${API_URL}/regions/${id}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify({ name }),
    }).then(handleResponse),

  deleteRegion: (id) =>
    fetch(`${API_URL}/regions/${id}`, {
      method: 'DELETE',
      headers: getHeaders(),
    }).then(handleResponse),

  toggleRegion: (id) =>
    fetch(`${API_URL}/regions/${id}/toggle`, {
      method: 'PATCH',
      headers: getHeaders(),
    }).then(handleResponse),

  // Public
  getPublicBrands: () =>
    fetch(`${API_URL}/public/brands`).then(handleResponse),

  getPublicRegions: () =>
    fetch(`${API_URL}/public/regions`).then(handleResponse),
};
